<template>
  <div>
    <b-row style="margin:30px 0px 10px">
      <b-col cols="12" v-if="uploadStarted === false">
        <b-form>
          <b-form-group
          id="input-group-1"
          label="Project title*:"
          label-for="input-1"
          :state="projectNameState"
          invalid-feedback="A project title is required"
          >
            <b-form-input
            id="input-1"
            v-model="projectName"
            placeholder="Enter project title (mandatory)"
            :state="projectNameState"
            required
            >
            </b-form-input>
          </b-form-group>

          <b-form-group
          id="input-group-2"
          label="Project description:"
          label-for="input-2"
          >
            <b-form-textarea
            id="input-2"
            v-model="projectDescription"
            placeholder="Enter a description for the project (optional)"
            required
            ></b-form-textarea>
          </b-form-group>
 
          <b-form-group
          id="input-group-3"
          label="Video*: "
          label-for="input-3"
          :state="projectFileState"
          invalid-feedback="A video file is required"
          >
            <div style="padding: 10px; border: 1px solid; border-radius:5px">

            Select among existing videos or upload a new one:
            <b-row class="align-items-center" style="margin:10px 0px">
              <b-col>
                <b-form-radio v-model="selectionMode" name="some-radios" value="select"> Existing videos</b-form-radio>
              </b-col>
              <b-col>
                <b-form-radio v-model="selectionMode" name="some-radios" value="upload">Upload a new video</b-form-radio>
              </b-col>
            </b-row>     

              <b-form-file v-if="selectionMode === 'upload'"
              id="input-3"
              v-model="projectFile"
              placeholder="Choose video to upload"
              accept="video/*"
              :state="projectFileState"
              required
              ></b-form-file>

              <b-form-input v-if="selectionMode === 'select'"
              placeholder="Search among existing videos"
              v-model="searchParams"
              @input="updateVideoList"
              ></b-form-input>

              <div v-if="selectionMode === 'select'" style="margin:10px">
                <small>
                  <div v-if="selectedVideo != null">
                    Selected video: <span style="color:#14BF98"> {{this.selectedVideo.title}} -  {{this.selectedVideo.createdDate}}</span>
                  </div>
                  <div v-if="selectedVideo === null">
                    Selected video: <span style="font-weight:bold"> None</span>
                  </div>
                </small>
              </div>
              
              <div v-if="selectionMode === 'select'" style="border: 1px solid #2F90B0">
                <ul 
                id="videoListResult" 
                style="list-style-type: none; padding:0px 10px"
                >
                  <li v-for="video in videosForList" :key="video.uuid" style="margin-top:10px" @click="selectVideo(video)">
                    <span v-if="selectedVideo != null && selectedVideo.title === video.title">
                      <div style="border: 1px solid #14BF98; padding:3px">
                        <b-img class="previewImg" style="object-fit:cover; width:10%; max-height:30px" :src="`${baseurl[video.type]}/contents/${(video.encodingStatus === 'segmented') ? 'passthrough' : 'encodings'}/${video.type}/${video.uuid}/thumbnail.jpg`" @error="imgUrlAlt" fluid></b-img> 
                        <small> {{video.title}} - {{video.createdDate}}</small>
                      </div>
                    </span>
                    <span v-else>
                      <b-img class="previewImg" style="object-fit:cover; width:10%; max-height:30px" :src="`${baseurl[video.type]}/contents/${(video.encodingStatus === 'segmented') ? 'passthrough' : 'encodings'}/${video.type}/${video.uuid}/thumbnail.jpg`" @error="imgUrlAlt" fluid></b-img> 
                      <small> {{video.title}} - {{video.createdDate}}</small>
                    </span>
                  </li>
                </ul>

                <b-pagination 
                style="font-size:70%"
                v-model="currentPage"
                :total-rows="totalRows"
                :per-page="4"
                aria-controls="videoListResult"
                align="center"
                ></b-pagination>
              </div>
            </div>
          </b-form-group>

          <b-form-group
          id="input-group-4"
          label=""
          label-for="input-4"
          :state="collabNameState"
          :invalid-feedback="invalidFeedbackCollab"
          >
            <div class="pointerEltVideo" style="margin:10px 0px" @click="addCollabs = !addCollabs">
              Add Collaborators: 
              <b-icon v-if="!addCollabs" icon="plus-circle"></b-icon>
              <b-icon v-if="addCollabs" icon="dash-circle"></b-icon>
            </div>

            <div v-if="addCollabs" style="padding: 10px; border: 1px solid; border-radius:5px">
              <b-row style="margin:10px 0px">
                <b-col cols="10">
                  <b-form-input
                  id="input-4"
                  placeholder="Search among usernames"
                  v-model="newCollabName"
                  :state="collabNameState"
                  required
                  list="usersList"
                  autocomplete="off"
                  ></b-form-input>
                  <b-form-datalist id="usersList" :options="usersList"></b-form-datalist>
                </b-col>
                <b-col cols="2">
                  <b-button variant="msstreamblue" @click="addCollab()" :disabled="addCollabButtonDisable">
                    <b-icon icon="plus-circle"></b-icon>
                  </b-button>
                </b-col>
              </b-row>
            
              <b-table show-empty centered responsive striped bordered :items="collaborators" :fields="collabTable">
                <template v-slot:cell(username)="row">
                  <div style="word-break:break-word">
                    {{row.item.username}}
                  </div>
                </template>
                <template v-slot:cell(role)="row">
                  <b-form-select
                  style="min-width:100px"
                  v-model="row.item.role"
                  :options="roles"
                  >
                  </b-form-select>
                </template>
                <template v-slot:cell(actions)="row">
                  <div style="text-align:center">
                    <!--<font-awesome-icon class="pointerEltVideo" style="padding:0px; margin: 0px 10px" icon="eye"></font-awesome-icon>-->
                    <font-awesome-icon class="pointerEltSB" style="padding:0px; margin: 0px 10px; color:red" icon="trash" @click="collabSelected = row.item; removeCollab()"></font-awesome-icon>
                  </div>
                </template>
              </b-table>

            </div>
          </b-form-group>

          <div class="pointerEltVideo" style="margin:10px 0px" @click="addTeams = !addTeams">
            Add Teams: 
            <b-icon v-if="!addTeams" icon="plus-circle"></b-icon>
            <b-icon v-if="addTeams" icon="dash-circle"></b-icon>
          </div>

          <b-form-group
          id="input-group-4"
          label=""
          label-for="input-4"
          :state="teamNameState"
          :invalid-feedback="teamNameFeedback"
          >
            <div v-if="addTeams" style="padding: 10px; border: 1px solid; border-radius:5px">
              <b-row style="margin:10px 0px">
                <b-col cols="10">
                  <b-form-input
                  id="input-4"
                  placeholder="Search among teams"
                  v-model="newTeamName"
                  :state="teamNameState"
                  required
                  list="teamsUser"
                  autocomplete="off"
                  ></b-form-input>
                  <b-form-datalist id="teamsUser" :options="teamsUserName"></b-form-datalist>
                </b-col>
                <b-col cols="2">
                  <b-button variant="msstreamblue" @click="addTeam()">
                    <b-icon icon="plus-circle"></b-icon>
                  </b-button>
                </b-col>
              </b-row>

              <b-table show-empty centered responsive striped bordered :items="teamsProject" :fields="teamsSelected">
                <template v-slot:cell(teamname)="row">
                  <div style="word-break:break-word">
                    {{row.item.teamName}}
                  </div>
                </template>
                <template v-slot:cell(descriptionTeam)="row">
                  <div style="word-break:break-word">
                    {{row.item.teamDescription}}
                  </div>
                </template>
                <template v-slot:cell(owner)="row">
                  <div style="word-break:break-word">
                    {{row.item.ownerTeam}}
                  </div>
                </template>
                <template v-slot:cell(actions)="row">
                  <div style="text-align:center; min-width:80px">
                    <font-awesome-icon class="pointerEltSB" style="padding:0px; margin: 0px 10px" icon="eye" @click="teamSelected = row.item" v-b-modal.modal-see-team ></font-awesome-icon>
                    <font-awesome-icon class="pointerEltSB" style="padding:0px; margin: 0px 10px; color:red" icon="trash" @click="teamSelected = row.item; removeTeam()" ></font-awesome-icon>
                  </div>
                </template>
              </b-table>
            </div>
          </b-form-group>

        </b-form>
        <b-button variant="msstreamblue" style="margin:20px 0px; width:100%" @click="createProject()">Create project</b-button>
      </b-col>

      <b-col cols ="12" v-if="uploadStarted === true">
        <div class="inputCard" v-for="(file2) in files" cols="12" xs="6" md="4" lg="4" v-bind:key="file2.filename">
          <h5 style="margin-top:8px">{{file2.name}}</h5>
          <p><strong>Size:</strong> {{Math.round(file2.size / 1000000)}} MB</p>
          <p v-if="file2.isLoading">Upload in progress...</p>
          <p v-if="file2.isLoadingEnd">Video uploaded.</p>
          <b-progress style="width:100%" v-if="file2.isLoading || file2.isLoadingEnd">
            <b-progress-bar :value="file2.loadingPercent" animated variant="primary">
              {{file2.loadingPercent}}%
            </b-progress-bar>
          </b-progress>
        </div>
      </b-col>
    </b-row>
    
    <b-modal
      id="modal-see-team"
      ref="modal-see-team"
      title="Team infos"
      @ok="resetModal"
      @show="resetModal"
      @hidden="resetModal"
      hide-footer
    >
      <b-card border-variant="msstream" no-body>
        <b-card-header
          header-bg-variant="gray"
          header-text-variant="#2a5d77"
          class="text-center"
        >
          <h5 style="margin:0px">
            {{teamSelected.teamName}}
            <b-badge v-if="teamSelected.collabsTeam !== undefined" title="Number of members in the team">{{teamSelected.collabsTeam.length}}</b-badge>
          </h5>
        </b-card-header>
        <b-table-simple stacked>
          <b-tbody>
            <b-tr>
              <b-td stacked-heading="Team Description">{{
                teamSelected.teamDescription
              }}</b-td>
              <b-td stacked-heading="Team Manager"><span style="color:#2F90B0"> {{ teamSelected.ownerTeam }}</span>
              </b-td>
              <b-td stacked-heading="Members w/ roles* in projects">
                <div v-for="(collab, idx) in teamSelected.collabsTeam" :key="idx"> 
                  <b-row class="align-items-center">
                    <b-col cols="8" style="padding:0px 0px 10px 15px">
                    {{ collab.username }}:
                    </b-col>
                    <b-col cols="4" style="padding:0px 0px 10px 10px">
                      {{ collab.role }}
                      <small>
                        <font-awesome-icon
                        v-if="collab.role === 'viewer'"
                        :icon="['fas', 'eye']"
                        style="color: black"
                        />
                        <font-awesome-icon
                        v-if="collab.role === 'editor'"
                        :icon="['fas', 'edit']"
                        style="color: black"
                        />
                        <font-awesome-icon
                        v-if="collab.role === 'admin'"
                        :icon="['fas', 'cog']"
                        style="color: black"
                        />
                        <font-awesome-icon
                        v-if="collab.role === 'owner'"
                        :icon="['fas', 'cog']"
                        style="color: #ba0000"
                        />
                      </small>
                    </b-col>
                  </b-row>
                </div>
              </b-td>
              
              <div @click="$router.push('/profil')" class="pointerEltSB" style="font-size:10px; margin:8px">*Those roles are the ones configured in the 'Teams List'. Go to the 'Manage Teams' section on your Profile for any action on Teams - only available to the <strong>Manager</strong> of the team.</div>
              <div style="font-size:10px; margin:8px">Changing the role of a collaborator for the project can be done on the Collaborator panel - only available to the <strong>Admins</strong> of the project.</div>
              
            </b-tr>
          </b-tbody>
        </b-table-simple>
      </b-card>

    </b-modal>


    <!--
    <b-modal
    id="modal-see-team"
    ref="modal-see-team"
    title=""
    @ok="resetModal"
    @show="resetModal"
    @hidden="resetModal"
    >
      <b-card border-variant="msstream" no-body>
        <b-card-header header-bg-variant="msstream" header-text-variant="white" class="text-center">
          <h4>Team information</h4>
        </b-card-header>
        <b-table-simple stacked>
          <b-tbody>
            <b-tr>
              <b-td stacked-heading="Team name">{{teamSelected.teamName}}</b-td>
              <b-td stacked-heading="Team Description">{{teamSelected.teamDescription}}</b-td>
              <b-td stacked-heading="Owner">{{teamSelected.ownerTeam}}</b-td>
            </b-tr>
          </b-tbody>
        </b-table-simple>
      </b-card>

      <b-card border-variant="msstream" no-body style="margin-top:20px">
        <b-card-header header-bg-variant="msstream" header-text-variant="white" class="text-center">
          <h4>Members</h4>
        </b-card-header>
        <b-table show-empty centered responsive striped bordered :items="teamSelected.collabsTeam">
        </b-table>
     </b-card>
    </b-modal>
-->

    <b-modal
    id="modal-add-team"
    ref="modal"
    title="Add a team to this project"
    @show="getTeams()"
    >
      <b-table show-empty centered responsive striped bordered :items="teamsUser" :fields="teamsTable">
        <template v-slot:cell(teamname)="row">
          {{row.item.teamName}}
        </template>

        <template v-slot:cell(descriptionTeam)="row">
          {{row.item.teamDescription}}
        </template>      

        <template v-slot:cell(owner)="row">
          {{row.item.ownerTeam}}
        </template>

        <template v-slot:cell(addteam)="row">
          <b-button variant="msstreamblue" @click="addTeam(row.item)">
            Add 
            <b-icon icon="plus-circle"></b-icon>
          </b-button>
        </template>
      </b-table>
    </b-modal>
       
  </div>
</template>

<script>
import ProjectService from "@/services/project.service.js";
import VideoService from "@/services/video.service.js";
import UserService from "@/services/user.service.js"
import TeamService from "@/services/team.service.js";
import { EventBus } from '@/event-bus.js';


import { BASE_READER, EMBED_URL } from "@/services/base-url";
let moment = require("moment");

var vService = new VideoService();
var Pservice = new ProjectService();
var uService = new UserService();
var tService = new TeamService();


export default {
    data: () => {
    return {
      baseurl: BASE_READER,
      projectFile: null,
      ShowCreateBtn: false,
      addCollabs: false,
      addTeams: false,
      collaborators: [],
      collaboratorsRoles: [],
      teams: [],
      selectedteams: [],
      teamsUserName:[],
      e6: 1,
      skiped: [0, 0, 0],
      valid: true,
      validFile: true,
      projectName: "",
      projectDescription: "",
      rules: [(v) => v.length <= 300 || "Max 300 azeazqsdcharacters"],
      requiredRule: [(v) => !!v || "Name is required"],
      fileRules: [
        (v) => !!v || "File is required",
        // (v) => (v && v.length > 0) || "File is required",
      ],
      roles: ["admin", "editor", "viewer"],
      newCollabName: "",
      collabNameState: null,
      projectNameState: null,
      projectFileState: null,
      teamNameState:null,
      teamNameFeedback:"",
      videosList:[],
      searchVideoResult:[],
      searchParams:"",
      selectionMode:"upload",
      selectedVideo:null,
      currentPage:1,
      invalidFeedbackCollab:"Collaborator's username is required",
      collabTable :
      [
        { key: "username", label: "Username", thClass: 'text-center', tdClass: 'align-middle'},
        { key: "role", label: "Role in project", thClass: 'text-center', tdClass: 'align-middle'},
        { key: "actions", label: "Actions", thClass: 'text-center', tdClass: 'align-middle'},
      ],
      usersList:[],
      teamsUser:[],
      teamsProject:[],
      teamsTable : 
      [
        { key: "teamname", label: "Team", thClass: 'text-center', tdClass: 'align-middle'},
        { key: "descriptionTeam", label: "Description", thClass: 'text-center', tdClass: 'align-middle'},
        { key: "owner", label: "Manager", thClass: 'text-center', tdClass: 'align-middle'},
        { key: "addteam", label: "Add team to project", thClass: 'text-center', tdClass: 'align-middle'}
      ],
      teamsSelected : 
      [
        { key: "teamname", label: "Team", sortable: true, thClass: 'text-center', tdClass: 'align-middle'},
        { key: "descriptionTeam", label: "Description", thClass: 'text-center', tdClass: 'align-middle'},
        { key: "owner", label: "Manager", thClass: 'text-center', tdClass: 'align-middle'},
        { key: "actions", label: "Actions", thClass: 'text-center', tdClass: 'align-middle'}
      ],
      teamName:"",
      teamDescription:"",
      teamSelected:"",
      uploadStarted:false,
      files : [],
      newTeamName:"",
      collabSelected:null,
      addCollabButtonDisable:false,
    };
  },
  methods: {
    addCollab()
      {
        this.addCollabButtonDisable = true;
        var idxCollab = this.collaborators.findIndex(collab => collab.username === this.newCollabName)

        if(idxCollab === -1)
        {
            if(!this.newCollabName)
            {
                this.invalidFeedbackCollab = "Collaborator's username is required"
                this.collabNameState = false;
                this.addCollabButtonDisable = false;

                return;
            }
            
            uService.getUser(this.$auth.token(), this.newCollabName)
            .then(response =>{
              this.addCollabButtonDisable = false;
              let newCollab = 
              {
                  username:this.newCollabName,
                  role:'viewer'
              }
              this.collaborators.push(newCollab);
            }).catch(err=>{
              this.addCollabButtonDisable = false;
              this.invalidFeedbackCollab = "User " + this.newCollabName + " not found";
              this.collabNameState = false;
            })
        }
        else{
          this.addCollabButtonDisable = false;
        }
    },
    createProject()
        {
            if(!this.projectName)
            {
                this.projectNameState = false;
            }
            else
            {
                this.projectNameState = true;                
            }

            if(!this.projectFile && this.selectionMode === "upload")
            {
                this.projectFileState = false;
            }
            else if(this.selectionMode === "upload")
            {
                this.projectFileState = true;
            }

            if(!this.selectedVideo && this.selectionMode === "select")
            {
                this.projectFileState = false;
            }
            else if(this.selectionMode === "select")
            {
                this.projectFileState = true;
            }

            if(!(this.projectFileState && this.projectNameState))
                return;


            if(this.selectionMode == "upload")
            {

              var videos = [];
              videos.push({type: "vod", title: this.projectFile.name, uploadingPercent: 0});
              this.files=[this.projectFile]

              vService.postVideos(videos, this.$auth.token()).then((result) => {
                this.uploadStarted = true;
                let video = result[0]
                let body = {
                    name: this.projectName,
                    description: this.projectDescription,
                    collabs: this.collaborators,
                    teams:[]
                };

                this.teamsProject.forEach(team=>{
                  body.teams.push(team.uuid)
                })

                Pservice.createProject(this.$auth.token(), body, video.video.uuid)
                .then(project=>{
                  this.uploadFiles(result);
                  EventBus.$emit('reloadProjectsList');
                  EventBus.$emit('preventCloseWindow', "New Project");
                })


              }).catch((err) => {
                console.log(err)
              })

              /**vService.postVideos(videos, this.$auth.token()).then((result) => {
              
              this.projectFile.loadingPercent = 0;
              this.uploadStarted = true;
              EventBus.$emit('preventCloseWindow', "ProjectForm");
              EventBus.$emit('reloadProjectsList');
              
              var video = result.shift();
              this.uploadFile(video, this.projectFile).then(()=>{
                EventBus.$emit("allowCloseWindow", "ProjectForm");
                this.uploadStarted = false;
              })

              }).catch((err) => {
                console.log(err)
              })**/


            }
            else if (this.selectionMode === "select")
            {
                let body = {
                    name: this.projectName,
                    description: this.projectDescription,
                    collabs: this.collaborators,
                    teams:[]
                };

                this.teamsProject.forEach(team=>{
                  body.teams.push(team.uuid)
                })

                Pservice.createProjectSelect(this.$auth.token(), body, this.selectedVideo.uuid)
                .then(project => {
                  EventBus.$emit('reloadProjectsList');
                  EventBus.$emit('closeCurrentWindow')
                })
                .catch((err) => {
                    console.log(err);
                })
            }


    },
    updateVideoList()
    {
      let params = this.searchParams;
      let newSearchResults = this.videosList.filter(v => v.title.toLowerCase().includes(params.toLowerCase()))

      this.searchVideoResult = newSearchResults
    },
    selectVideo : function (video)
    {
      this.selectedVideo = video;
    },
    imgUrlAlt(event) {
      event.target.src = `/thumbnail.jpg`;
    },
    getTeams()
    {
      this.teamsUser = [];

      tService.getTeams(this.$auth.token())
      .then(teams=>{
        for(let i = 0;i<teams.length;i++)
        {
          if(!this.teamsProject.find(projTeam => projTeam.uuid === teams[i].uuid))
          {
            this.teamsUserName.push(teams[i].teamName)
            this.teamsUser.push(teams[i])
          }
        }
      })
    },
    addTeam()
    {
      var idxTeamAdd = this.teamsProject.findIndex(teamProject => teamProject.teamName === this.newTeamName)

      var idxTeam = this.teamsUser.findIndex(teamUser => teamUser.teamName === this.newTeamName)
      if(idxTeam != -1)
      {
        if(idxTeamAdd === -1)
        {
          this.teamNameState = null;
          this.teamNameFeedback = ""
          var team = this.teamsUser[idxTeam];
          this.teamsProject.push(team)
        }
      }
      else{
        this.teamNameState = false;
        this.teamNameFeedback = `The team ${this.newTeamName} does not exist`
      }


      //this.teamsUser.splice(idxTeam,1)
    },
    resetModal()
    {
      this.teamName = "";
      this.teamDescription = "";
      this.collaborators = [];
    },
    removeTeam()
    {
      var idxTeam = this.teamsProject.findIndex(team => team.uuid === this.teamSelected.uuid)

      this.teamsProject.splice(idxTeam,1)
    },
    uploadFiles(results) {
      var chunkSize = 5 * 1000000;
      this.uploadstarted = true;
      function slice(file, start, end) {
        var slice = file.mozSlice ? file.mozSlice :
                    file.webkitSlice ? file.webkitSlice :
                    file.slice ? file.slice : noop;
        
        return slice.bind(file)(start, end);
      }

      var uploadFile = (video, fileIndex) => {
        let seconds_to_days_hours_mins_secs_str =function(seconds) { 
          var hours    = Math.floor(seconds / (60*60));
              seconds -= hours   * (60*60);
          var minutes  = Math.floor(seconds / (60));
              seconds -= minutes * (60);
          if (minutes < 10 && hours > 0) {
              minutes = "0" + minutes;
          }
          if ((minutes > 0 || hours > 0) && seconds < 10) {
              seconds = "0" + seconds;
          }
          
          return ((0<hours)?(hours+":"):"") + ((0<minutes || hours > 0)?(minutes+":"):"") +seconds+"s";
        }

        return new Promise((done, reject) => {
          self = this;
          self.files[fileIndex].isLoading = true;
          self.files[fileIndex].isLoadingEnd = false;
          self.files[fileIndex].isLoadingError = false;
          self.files[fileIndex].loadingPercent =  0;
          self.files[fileIndex].currentData =  0;
          self.files[fileIndex].currentChunk =  1;
          self.files[fileIndex].startDate =  new Date();
          self.files = self.files.splice(0, self.files.length);

          var sendNextData = function() {
            var start = self.files[fileIndex].currentData;
            var size = self.files[fileIndex].size;
            var end = start + chunkSize;
            var isEnd = false;
            
            if (size - end <= 0) {
              end = size;
              isEnd= true;
            }

            var data = slice(self.files[fileIndex], start, end);
            vService.postChunk(video.video.uuid, self.files[fileIndex].currentChunk, data, self.files[fileIndex].name, isEnd, self.$auth.token()).then(() => {
              if (isEnd) {
                self.files[fileIndex].isLoading = false;
                self.files[fileIndex].isLoadingError = false;
                self.files[fileIndex].isLoadingEnd = true;
                self.files[fileIndex].loadingPercent =  100;
                vService.putVideoById({uploadingPercent: 100, uploadingETA: '0s', lastUploadingFeedbackDate: new Date()}, video.video.uuid, self.$auth.token()).then(() =>{}).catch(err => {});
                self.files = self.files.splice(0, self.files.length);
                
                done();
              } else {
                var start = self.files[fileIndex].currentData += chunkSize;
                self.files[fileIndex].currentChunk += 1
                self.files[fileIndex].loadingPercent =  Math.round(100 * self.files[fileIndex].currentData / self.files[fileIndex].size);

                let currentDate = new Date();
                let currentPercent = self.files[fileIndex].loadingPercent;
                let timeSpentMS = currentDate.getTime() - self.files[fileIndex].startDate.getTime();
                let estimatedEndDuration = Math.round(timeSpentMS * 100 / currentPercent);
                let estimatedEndDate = new Date(self.files[fileIndex].startDate.getTime() + estimatedEndDuration);
                let durationUntilEnd = seconds_to_days_hours_mins_secs_str(Math.round((estimatedEndDate.getTime() - currentDate.getTime()) / 1000))
                vService.putVideoById({uploadingPercent: self.files[fileIndex].loadingPercent, uploadingETA: durationUntilEnd, lastUploadingFeedbackDate: currentDate}, video.video.uuid, self.$auth.token()).then(() =>{}).catch(err => {});
                
                self.files = self.files.splice(0, self.files.length);
                setTimeout(sendNextData, 1);
              }

            }).catch((err) => {
                self.files[fileIndex].isLoading = false;
                self.files[fileIndex].isLoadingEnd = false;
                self.files[fileIndex].isLoadingError = true;
                self.files[fileIndex].loadingPercent =  0;
                self.files = self.files.splice(0, self.files.length);

                done()
            })
          }
          sendNextData();

        })
      }

      var video = results[0];
      var fileIndex = this.files.findIndex((elem) => {return elem.name === video.video.originalname});

      uploadFile(video, fileIndex).then(() => {
        results.shift();
        if (results.length > 0) {
          this.uploadFiles(results);
        } else {
          this.files = [];
          this.uploadStarted = false;
          //document.location.href = document.location.href.split('?uploading=true')[0];
          EventBus.$emit("allowCloseWindow", "New Project");
          EventBus.$emit('closeCurrentWindow')
          
          //this.$router.push('/');
        }
      }).catch((err) => {
        EventBus.$emit("allowCloseWindow", "New Project");
        console.log(err);
      })
    },
    removeCollab(){
      var idxCollab = this.collaborators.findIndex(collab => collab.username === this.collabSelected.username)

      this.collaborators.splice(idxCollab, 1)
    }
  },
    computed:
  {
    totalRows ()
    {
      return this.searchVideoResult.length;
    },

    videosForList() {
      return this.searchVideoResult.slice(
        (this.currentPage - 1) * 4,
        this.currentPage * 4,
      );
    },
  },
  beforeMount()
  {
    this.usersList = []
    uService.getUsers(this.$auth.token())
    .then(users=>{
      users.forEach(user=>{
      this.usersList.push(user.username)
      })
    })

    this.getTeams();

    vService.getVideosForClient(this.$auth.token())
      .then((response)=>{
        this.videosList = response;
        this.searchVideoResult = this.videosList;
        //for(let video in this.videosList)
        this.videosList.forEach(function(video)
        {
          video.createdDate = moment(
          video.createdAt).format("DD/MM/YY @HH:mm");
        });
        this.videosList.sort((a, b) => new Date(b.createdAt)-new Date(a.createdAt))

      }).catch((error)=>{
        console.log(error)
      })
  }




}
</script>